// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"170":"9950f208","505":"bdbc4aaf","843":"7addd05a","847":"8d521b59"}[chunkId] + ".chunk.js";
};